module.exports = __webpack_public_path__ + "img/cancel_c.38333aa3.png";